import {ProvisionRunStatus} from './provision-run-status.enum';

/**
 * BUSINESS order of the ProvisionRun step bar — deliberately NOT the ordinal order (04-frontend.md
 * §5.2, binding, U-09). CALCULATION_FAILED(9)/ACTIVATION_FAILED(10)/PAYOUT_FAILED(11)/ABORTED(12)
 * carry the highest ordinals because they were appended last, but they are reachable from earlier
 * business steps and are NOT part of the linear step bar — the step-flow component renders them as
 * a badge on the affected step (FAILED) resp. a terminal banner (ABORTED), never as a step of their
 * own. Deriving progress from the ordinal would misplace a failed/aborted run.
 *
 * The status-bar test asserts against THIS list, not against ordinals (DA-017.6). Special states
 * outside the bar:
 *   CALCULATION_FAILED(9)  -> badge on step 2 (VertrÃ¤ge berechnen)
 *   ACTIVATION_FAILED(10)  -> badge on step 3 (VertrÃ¤ge aktiviert)
 *   PAYOUT_FAILED(11)      -> badge on step 4 (VertrÃ¤ge ausgezahlt)
 *   ABORTED(12)            -> terminal banner
 */
export const CP_RUN_STATUS_ORDER: ProvisionRunStatus[] = [
    ProvisionRunStatus.NEW,             // 0
    ProvisionRunStatus.IN_CALCULATION,  // 1
    ProvisionRunStatus.CALCULATED,      // 2
    ProvisionRunStatus.IN_REVIEW,       // 3
    ProvisionRunStatus.IN_ACTIVATION,   // 4
    ProvisionRunStatus.ACTIVATED,       // 5
    ProvisionRunStatus.IN_PAYOUT,       // 6
    ProvisionRunStatus.PAID_OUT,        // 7
    ProvisionRunStatus.COMPLETED        // 8
];
